var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 37.3,
    viewBox: "0 0 35 37.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_162401",
    "data-name": "Group 162401",
    transform: "translate(-1610 -63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(1611 74.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83086",
    "data-name": "Path 83086",
    d: "M22.167,10.12A7.9,7.9,0,0,0,14.5,2a7.9,7.9,0,0,0-7.667,8.12C6.833,19.593,3,22.3,3,22.3H26s-3.833-2.707-3.833-12.18",
    transform: "translate(-3 -2)",
    fill: "#2699fb",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83087",
    "data-name": "Path 83087",
    d: "M13.73,21a2,2,0,0,1-3.46,0",
    transform: "translate(-0.5 3.299)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "message-circle",
    transform: "translate(1624 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "message-circle-2",
    "data-name": "message-circle",
    d: "M23,12.444a9.311,9.311,0,0,1-1,4.222,9.444,9.444,0,0,1-8.444,5.222,9.311,9.311,0,0,1-4.222-1L3,23l2.111-6.333a9.311,9.311,0,0,1-1-4.222A9.444,9.444,0,0,1,9.333,4a9.311,9.311,0,0,1,4.222-1h.556A9.422,9.422,0,0,1,23,11.889Z",
    transform: "translate(-3 -3)",
    fill: "#fb4d4d",
    stroke: "#fb4d4d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.d01874e3e32ab2b458732f743b1d068d.svg";
export { ForwardRef as ReactComponent };